import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import { COLUMNS_OP } from "./Columns";
import { GlobalFilter } from "./GlobalFilter";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { Link, useHistory } from "react-router-dom";
import "./filtering.css";
import { getAllOrdenesDePago, insertOrdenDePago } from "../../api/ordenesDePagoApi";
import Swal from "sweetalert2";
import { getUserCredentials } from "../../api/usuarioApi";
import { getAdminById } from "../../api/AdminApi";
import ModalAgregarOrden from "./ordendepago/ModalAgregarOrden";

export const Ordendepago = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  // Chequeo de permisos y carga inicial
  useEffect(() => {
    const checkPermissionAndLoad = async () => {
      setLoading(true);
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);
        if (USERDATA?.cierres === "false") {
          setHasPermission(false);
          setLoading(false);
          return;
        }
        setHasPermission(true);
      } catch (e) {
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermissionAndLoad();
  }, [history]);

  // Cargar datos cuando se tiene permiso
  const assigmentValue = useCallback(async () => {
    try {
      setLoading(true);
      const result = await getAllOrdenesDePago();
      setData([...result]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (hasPermission === true) {
      assigmentValue();
    }
  }, [hasPermission, assigmentValue]);

  const columns = useMemo(() => COLUMNS_OP, []);
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFilters,
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // Spinner loading simple, centrado SOLO dentro de la página, no cubre el sidebar
  if (loading) {
    return (
      <div style={{
        minHeight: "60vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        zIndex: 2
      }}>
        <div style={{
          width: 38,
          height: 38,
          border: "4px solid #ddd",
          borderTop: "4px solid #1569c9ff",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>Cargando...</span>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg);}
              100% { transform: rotate(360deg);}
            }
          `}
        </style>
      </div>
    );
  }

  if (hasPermission === false) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );
  }

  if (hasPermission !== true) {
    return null;
  }

  // Importá tu función de API donde corresponda
  // import { insertOrdenDePago } from "ruta/a/tu/api/ordenDePagoApi";

  const onReturnData = async (data) => {
    // Normalizar/asegurar descripción
    const descripcionNormalizada =
      (data.descripcion ?? "").trim().length === 0
        ? "Sin Descripcion"
        : data.descripcion.trim();

    const payload = {
      fechainicio: data.fechaInicio, // mapeo de nombres
      fechafin: data.fechaFin,
      descripcion: descripcionNormalizada,
    };

    try {
      const res = await insertOrdenDePago(payload);

      // Si llegó acá, guardó OK → cerrar modal y avisar
      handleCloseModal();

      await Swal.fire({
        icon: "success",
        title: "Orden creada",
        text: "La orden de pago fue agregada correctamente.",
        timer: 1800,
        showConfirmButton: false,
      });
      // Opcional: recargar listado / re-fetch
      // await fetchOrdenes();
      return res;
    } catch (err) {
      // insertOrdenDePago ya mostró el SweetAlert de error
      console.error("Error al crear la orden:", err);
      // NO cerramos el modal en error; el usuario puede corregir y reintentar
    }
  };

  return (
    <>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Ordenes de pagos</h4>
          <ButtonGroup aria-label="Basic example">
            <Button variant="primary" onClick={handleOpenModal}>
              Agregar Orden de Pago
            </Button>
          </ButtonGroup>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            <table {...getTableProps()} className="table dataTable display">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                        {column.canFilter ? column.render("Filter") : null}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()} className="">
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          style={{
                            padding: "10px",
                          }}
                        >
                          <Link
                            to={{
                              pathname: "/fichaorden/" + row.values.idordendepago,
                              state: {
                                ...row.original
                              },
                            }}
                          >
                            {cell.render("Cell")}
                          </Link>
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="d-flex justify-content-between">
              <span>
                Página{" "}
                <strong>
                  {pageIndex + 1} de {pageOptions.length}
                </strong>
                {""}
              </span>
              <span className="table-index">
                Ir a página:{" "}
                <input
                  type="number"
                  className="ml-2"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const pageNumber = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(pageNumber);
                  }}
                />
              </span>
            </div>
            <div className="text-center mb-3">
              <div className="filter-pagination mt-3">
                <button
                  className="previous-button"
                  onClick={() => gotoPage(0)}
                  disabled={!canPreviousPage}
                >
                  {"<<"}
                </button>
                <button
                  className="previous-button"
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                >
                  Anterior
                </button>
                <button
                  className="next-button"
                  onClick={() => nextPage()}
                  disabled={!canNextPage}
                >
                  Siguiente
                </button>
                <button
                  className="next-button"
                  onClick={() => gotoPage(pageCount - 1)}
                  disabled={!canNextPage}
                >
                  {">>"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalAgregarOrden
        show={showModal}
        handleClose={handleCloseModal}
        refreshData={assigmentValue}
        onReturnValue={onReturnData}
      />
    </>
  );
};

export default Ordendepago;